import { render, staticRenderFns } from "./Sudionici.vue?vue&type=template&id=e4d3e0fe&"
import script from "./Sudionici.vue?vue&type=script&lang=js&"
export * from "./Sudionici.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports